import { SERVICE_CALLBACK } from "../ultils";

const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
const Call = async (path, method, body = null, headers = {}) => {
  var options = {
    method: method,
    credentials: "include",
    headers: {
      ...headers,
    },
    body: body ? JSON.stringify(body) : null,
  };
  const result = await fetch(`${BASE_API_URL}${path}`, options);
  return result;
};
const encodeAuthCre = (u, p) => {
  return btoa(`${u}:${p}`);
};
const Services = {
  // User - public
  UserPublic: {
    register: async (
      username,
      password,
      confirm_pwd,
      display_name,
      email,
      ref_id
    ) =>
      Call("/user/register", "POST", {
        username,
        password,
        confirm_password: confirm_pwd,
        display_name,
        email,
        ref_id,
      }),
    login: async (username, password) =>
      Call("/user/login", "POST", { username, password }),
    forgotPasswordBegin: async (email) =>
      Call("/user/forgot-password-begin", "POST", { email }),
    forgotPasswordFinish: async (token, new_password, confirm_new_password) =>
      Call("/user/forgot-password-finish", "POST", {
        token,
        new_password,
        confirm_new_password
      })
  },

  // User - auth
  UserAuth: {
    logout: async () => Call("/user/logout", "POST"),
    me: async () => Call("/user/me", "GET"),
    getSubscriptions: async () => Call("/user/subscriptions", "GET"),
    sendVerifyCode: async () => Call("/user/send-verify-code", "POST"),
    verifyCode: async (code) => Call("/user/verify", "POST", { code }),
    resetPassword: async (current_password, new_password, confirm_new_password) =>
      Call("/user/password", "PUT", {
        current_password,
        new_password,
        confirm_new_password
      }),
  },

  // API Key
  APIKey: {
    get: async () => Call("/user/apikey", "GET"),
    create: async (secret = null) => Call("/user/apikey", "POST", { secret }),
    update: async (secret, name) => Call(`/user/apikey?secret=${secret}&name=${name ?? ""}`, "PUT"),
    delete: async (secret) => Call(`/user/apikey?secret=${secret}`, "DELETE"),
    grantPermission: async (secret, subscription_id) =>
      Call(`/user/apikey/permissions?secret=${secret}&subscription_id=${subscription_id}`, "POST"),
    revokePermission: async (secret, subscription_id) =>
      Call(`/user/apikey/permissions?secret=${secret}&subscription_id=${subscription_id}`, "DELETE"),
  },

  // Subscription
  Subscription: {
    preview: async (
      service_callback,
      requests_limit = null,
      total_money_usd = null,
      concurrency = null
    ) => {
      let url = `/user/subscription/preview?service_callback=${service_callback}`;
      if (service_callback === SERVICE_CALLBACK.FB_GRAPH) {
        if (requests_limit !== null) url += `&requests_limit=${requests_limit}`;
        if (total_money_usd !== null) url += `&total_money_usd=${total_money_usd}`;
        if (concurrency !== null) url += `&concurrency=${concurrency}`;
      } else if (service_callback === SERVICE_CALLBACK.TIKTOK) {
        if (concurrency !== null) url += `&concurrency=${concurrency}`;
      }
      else if (service_callback === SERVICE_CALLBACK.FB_ACTION) {
        if (concurrency !== null) url += `&concurrency=${concurrency}`;
      }
      return Call(url, "GET");
    },
    create: async (
      service_callback,
      requests_limit = null,
      total_money_usd = null,
      concurrency = null
    ) => {
      let url = `/user/subscription/create?service_callback=${service_callback}`;
      if (service_callback === SERVICE_CALLBACK.FB_GRAPH) {
        if (requests_limit !== null) url += `&requests_limit=${requests_limit}`;
        if (total_money_usd !== null) url += `&total_money_usd=${total_money_usd}`;
      } else if (service_callback === SERVICE_CALLBACK.TIKTOK) {
        if (concurrency !== null) url += `&concurrency=${concurrency}`;
      }
      else if (service_callback === SERVICE_CALLBACK.FB_ACTION) {
        if (concurrency !== null) url += `&concurrency=${concurrency}`;
      }
      return Call(url, "POST");
    },
    renew: async (id) => Call(`/user/subscription/renew?id=${id}`, "POST"),
    changeAutoRenew: async (id, on_expired, on_reached_limit) =>
      Call("/user/subscription/auto-renew", "POST", {
        id,
        on_expired,
        on_reached_limit,
      }),
    updateName: async (id, name) =>
      Call(`/user/subscription/name?id=${id}&name=${name ?? ""}`, "POST"),
    createFreemium: async (service_callback) =>
      Call(
        `/user/subscription/freemium?service_callback=${service_callback}`,
        "POST"
      ),
    migrate: async (id) =>
      Call(`/user/subscription/migrate?access_token=${id}`, "GET"),
    getByAccessToken: async (access_token) =>
      Call(`/subscription?access_token=${access_token}`, "GET"),
  },

  // Deposit
  Deposit: {
    getPayments: async () => Call("/user/payments", "GET"),
    getDeposits: async (status = "") =>
      Call(`/user/deposits?status=${status}`, "GET"),
    getDepositMethods: async () => Call(`/user/deposit/methods`, "GET"),
    create: async (amount, method_callback) =>
      Call("/user/deposit", "POST", { amount, method_callback }),
    updateTransId: async (id, trans_id, sender_name) =>
      Call("/user/deposit", "PUT", { id, trans_id, sender_name }),
    cancel: async (id) => Call(`/user/deposit?id=${id}`, "DELETE"),
  },

  // Service Usage
  ServiceUsage: {
    getGlobal: async (rangeMinutes, serviceCallback) =>
      Call(`/service-usages/global?range_minute=${rangeMinutes}&service_callback=${serviceCallback}`, "GET"),
    getPersonal: async (rangeMinutes, serviceCallback) =>
      Call(`/service-usages/personal?range_minute=${rangeMinutes}&service_callback=${serviceCallback}`, "GET"),
  },

  // Service
  Service: {
    fbgraph: async (params = "") => Call(`/services/fbgraph?${params}`, "GET"),
    tiktok: async (input, access_token) => Call(`/services/tiktok?input=${input}&access_token=${access_token}`, "GET"),
    getAll: async () => Call("/services", "GET"),
  },

  // Executor
  Executor: {
    getAPIKeys: async () => Call("/executor", "GET"),
    updateSubscriptionUsedCache: async (data) => Call("/executor", "PUT", data),
    updateServiceUsage: async (data) => Call("/executor", "POST", data),
  },

  // Admin
  Admin: {
    me: async (u, p) =>
      Call("/admin/me", "GET", null, {
        Authorization: `Basic ${encodeAuthCre(u, p)}`,
      }),
    getUsers: async (u, p) =>
      Call("/admin/users", "GET", null, {
        Authorization: `Basic ${encodeAuthCre(u, p)}`,
      }),
    createSubscription: async (u, p, data) =>
      Call("/admin/subscriptions", "POST", data, {
        Authorization: `Basic ${encodeAuthCre(u, p)}`,
      }),
    updateSubscription: async (u, p, id, data) =>
      Call(`/admin/subscriptions?id=${id}`, "PUT", data, {
        Authorization: `Basic ${encodeAuthCre(u, p)}`,
      }),
    deleteSubscription: async (u, p, id) =>
      Call(`/admin/subscriptions?id=${id}`, "DELETE", null, {
        Authorization: `Basic ${encodeAuthCre(u, p)}`,
      }),
    getDeposits: async (u, p, status = "") =>
      Call(`/admin/deposits?status=${status}`, "GET", null, {
        Authorization: `Basic ${encodeAuthCre(u, p)}`,
      }),
    verifyDeposit: async (u, p, id) =>
      Call(`/admin/deposits/approve?id=${id}`, "POST", null, {
        Authorization: `Basic ${encodeAuthCre(u, p)}`,
      }),
    getGeneralInfo: async (u, p) =>
      Call("/admin/general", "GET", null, {
        Authorization: `Basic ${encodeAuthCre(u, p)}`,
      }),
    getMBHistory: async (u, p) =>
      Call("/admin/mb-history", "GET", null, {
        Authorization: `Basic ${encodeAuthCre(u, p)}`,
      }),
    callCronJob: async (u, p) =>
      Call("/admin/cron", "GET", null, {
        Authorization: `Basic ${encodeAuthCre(u, p)}`,
      }),
    healthCheck: async (u, p) =>
      Call("/ping", "GET", null, {
        Authorization: `Basic ${encodeAuthCre(u, p)}`,
      }),
  },

  // Others
  globalUsage: async (range_minute) =>
    Call(`/global/usage?range_minute=${range_minute}`, "GET"),

  priceLogs: async () => {
    return await Call(`/price/logs`, 'GET');
  },

  callGraph: async (apiPath, selectedToken) => {
    var options = {
      method: "GET",
      credentials: "include",
    };
    if (!apiPath.includes("?")) apiPath += "?";
    apiPath += `&access_token=${selectedToken}`;
    return fetch(`http://localhost/graph${apiPath}`, options);
  },

  resourcesCheck: async () => {
    var options = {
      method: "GET",
      credentials: "include",
      headers: {
        "whats-the-password": "iseedeadpeople",
      },
    };
    return await fetch("https://api.akng.io.vn/system/general", options);
  },

  CloneManager: {
    getProducts: async (u, p) => Call("/admin/clone/products", "GET", null, {
        Authorization: `Basic ${encodeAuthCre(u, p)}`,
      }),
    getProduct: async (u, p, product_id) =>
      Call(`/admin/clone/product?product_id=${product_id}`, "GET", null, {
        Authorization: `Basic ${encodeAuthCre(u, p)}`,
      }),
    buyProduct: async (u, p, product_id, amount) =>
      Call(`/admin/clone/buy?product_id=${product_id}&amount=${amount}`, "POST", null, {
        Authorization: `Basic ${encodeAuthCre(u, p)}`,
      }),
  }
};

export default Services;
